module.exports = __webpack_public_path__ + "img/bitbucket.01c663d1.png";